import React, { ReactNode } from 'react';
import classnames from 'classnames';

import './FormRow.scss';

type FormRow$Props = {
  children: ReactNode;
  noMargin?: boolean;
  className?: string;
};

export default function FormRow({ children, className, noMargin }: FormRow$Props) {
  return <div className={classnames(noMargin ? 'formRowNoMargin' : 'formRow', className)}>{children}</div>;
}
